

























import {Component, Vue, Watch} from 'vue-property-decorator';
import DatePicker from '@/screens/dashboard/event/DatePicker.vue';
import {ModuleOrganization} from '@/store/modules/OrganizationModule';
import {ModuleShop} from '@/store/modules/ShopModule';
import {getListFacebookPixelEvents} from '@/services/FacebookPixelService';
import TypeSelection from '@/screens/dashboard/event/TypeSelection.vue';
import EventsFollowAdsTable from '@/screens/dashboard/event/EventsFollowAdsTable.vue';
import EventsFollowCampaignTable from '@/screens/dashboard/event/EventsFollowCampaignTable.vue';
import EventsFollowFacebookPixelTable from '@/screens/dashboard/event/EventsFollowFacebookPixelTable.vue';

import {IDataEvent} from '@/models/IDataEvent';

@Component({
  components: {
    DatePicker,
    TypeSelection,
    EventsFollowAdsTable,
    EventsFollowCampaignTable,
    EventsFollowFacebookPixelTable
  }
})
export default class EventsAnalyticsScreen extends Vue {
  date: string = new Date().toISOString().substr(0, 10);
  loading: boolean = true;
  data: IDataEvent[] = [];
  type: string = '';

  get organizationId() {
    return ModuleOrganization.organizationId;
  }

  get shopId() {
    return ModuleShop.shopId;
  }

  onChangeCurDateTime(date: string) {
    this.date = date;
  }

  onChangeCurType(type: string) {
    this.type = type;
  }

  get curType() {
    return this.type;
  }

  get dateTime() {
    return this.date;
  }

  @Watch('shopId', {immediate: false})
  @Watch('dateTime', {immediate: false})
  @Watch('curType', {immediate: false})
  public async loadData() {
    this.loading = true;
    try {
      this.data = [];
      this.data = await getListFacebookPixelEvents(this.organizationId, this.shopId, this.dateTime, this.curType);
    } finally {
      this.loading = false;
    }
  }
}
